(ns frontend.ui.component.lp-portal.report.body.lifeline.fund.common 
  (:require
   [clojure.string :as s]
   [frontend.state.current-session :as session]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.style.theme.core :as theme]))

(defn toc-page-with-table
  [{:keys [cover-image report-data]}]
  (let [table-node (horizontal-table-pdf/horizontal-table-pdf
                    {:parsed-data              (->> report-data
                                                    :contacts
                                                    :figures)
                     :odd-row-background-color (theme/color [:lp-report :table :pdf :odd-row :bg])
                     :even-row-background-color (theme/color [:lp-report :table :pdf :even-row :bg])
                     :heading-color            (theme/color [:lp-report :table :pdf :heading-color :bg])
                     :heading-info-color       (theme/color [:lp-report :table :pdf :heading-info-color :bg])
                     :subheading-color         (theme/color [:lp-report :table :pdf :subheading-color :bg])
                     :subtotal-color           (theme/color [:lp-report :table :pdf :subtotal-color :bg])
                     :total-color              (theme/color [:lp-report :table :pdf :total-color :bg])
                     :empty-line-color         (theme/color [:lp-report :table :pdf :empty-line-color :bg])
                     :font-size                12})]
    [(page/page
      ""
      {:stack
       [{:absolutePosition {:x 0 :y 0}
         :image cover-image
         :width 842
         :height 595}
        {:absolutePosition {:x 230 :y 380}
         :stack [{:text     (s/upper-case (or (:fund-name report-data) ""))
                  :fontSize 22
                  :font "SuperiorTitleBlack"
                  :color    "#000000"
                  :margin   [0 0 0 0]}
                 {:text     (str (-> report-data
                                     :reporting-period
                                     (s/upper-case)) " Investor report")
                  :fontSize 14
                  :color    "#000000"
                  :margin   [100 0 0 12]}]}

        {:absolutePosition {:x 245 :y 460}
         :stack [table-node]}
        {:absolutePosition {:x 330 :y 540}
         :fontSize 12
         :text (str (or (:tenant/reporting-contact-email @session/tenant)
                        "finance@lifelineventures.com"))}]})]))

(defn- no-borders-layout
  []
  {:hLineWidth    (fn [_ _] 0)
   :vLineWidth    (fn [_ _] 0)
   :paddingLeft   (fn [_ _] 0)
   :paddingRight  (fn [_ _] 0)
   :paddingTop    (fn [_ _] 0)
   :paddingBottom (fn [_ _] 0)})

(defn lifeline-holdings-title-page
  [title]
  (page/page
   nil
   [{:absolutePosition {:x 0 :y 0}
     :canvas [{:type  :rect
               :x     0
               :y     0
               :w     page/page-width
               :h     page/page-height
               :color "#00BE8D"}]}
    {:absolutePosition {:x 0
                        :y (- (/ page/page-height 2) 40)}
     :table {:widths [page/page-width]
             :body   [[{:text      "Portfolio companies"
                        :fontSize  50
                        :font "SuperiorTitleBlack"
                        :bold      true
                        :alignment "center"}]
                      [{:text      title
                        :fontSize  30
                        :color     "grey"
                        :alignment "center"
                        :margin [0 -30 0 0]}]]}
     :layout (no-borders-layout)}]))

(defn all-data-rows-empty?
  [data key]
  (->> data
       key
       :figures
       :rows
       (filter (fn [{:keys [row-data]}]
                 (seq (remove nil? row-data))))
       (count)
       (= 0)))
